<template>
  <div
    class="insight"
    v-if="_.get(contentData, 'data.list[0].content.tabs')"
    :class="[
      $store.getters['main/getBackgroundTone'](evenOdd),
      {
        twoClass: _.size(_.get(contentData, 'data.list[0].content.tabs')) == 2,
        oneClass: _.size(_.get(contentData, 'data.list[0].content.tabs')) == 1
      }
    ]"
  >
    <div class="inner container">
      <div class="top-cont">
        <p class="font-38 tbc-medium ">
          {{ _.get(contentData, `conf.header.title`) }}
        </p>
      </div>
      <div class="content">
        <div
          class="box"
          :key="index"
          v-for="(data, index) in _.get(
            contentData,
            'data.list[0].content.tabs'
          ).slice(0, 3)"
        >
          <img
            class="img-absolute"
            :src="_.get(data, 'images[0].devices.desktop')"
          />
          <div class="data-cont">
            <p class="title font-38 tbc-bold">{{ _.get(data, "title") }}</p>
            <p
              class="txt font-16 tbc-medium text"
              v-html="_.get(data, 'content')"
            ></p>
            <a
              :href="_.get(data, 'url.url')"
              class="readMore font-16 tbc-bold uppercase"
            >
              <div class="icon">
                <svg
                  id="Group_5_Copy_3"
                  data-name="Group 5 Copy 3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="11.352"
                  height="11.351"
                  viewBox="0 0 11.352 11.351"
                >
                  <path
                    id="Combined_Shape_Copy_2"
                    data-name="Combined Shape Copy 2"
                    d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                    fill="#00a3e0"
                  />
                </svg>
              </div>
              <p class="tbc-bold">{{ _.get(data, "url.title") }}</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData", "evenOdd"],

  data() {
    return {};
  }
};
</script>

<style>
.insight .inner {
  padding-top: 90px;
  padding-bottom: 90px;
}
.insight .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 7px;
}
.insight .inner .content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 44px;
}
.insight .inner .content .box:first-child {
  margin-left: 0px;
}
.insight .inner .content .box {
  width: 350px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  padding-bottom: 377px;
  margin-left: 30px;
}
.insight.oneClass .inner .content .box {
  width: 100%;
}
.insight.twoClass .inner .content .box:nth-child(1) {
  flex: 2;
}
.insight .inner .content .box img {
  z-index: 1;
  opacity: 0.5;
}

.insight .readMore p {
  cursor: pointer;
}
.insight .inner .content .box .data-cont {
  position: absolute;
  z-index: 3;
  bottom: 50px;
  left: 55px;
  right: 20px;
  /* max-width: 275px; */
}
.insight .inner .content .box .data-cont .title {
  color: #ffffff;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.insight .inner .content .box .data-cont .txt {
  margin-top: 19px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.insight .inner .content .box .data-cont .txt * {
  color: #ffffff;
  line-height: 24px;
}
.insight .inner .content .box .data-cont a {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  color: #00a3e0;
  background: #1d2934;
  padding: 0 30px;
  width: max-content;
  border-radius: 6px;
  padding: 24px;
  margin-top: 32px;
}
.insight .inner .content .box .data-cont a .icon {
  transition: 0.6s;
  transition-delay: unset;
}
.insight .inner .content .box .data-cont a p {
  color: #00a3e0;
  transition: 0.6s;
  transition-delay: 0.3s;
}

@media (min-width: 1024px) {
  .insight .inner .content .box .data-cont a:hover p {
    transform: translateX(10px);
    transition-delay: unset;
  }
  .insight .inner .content .box .data-cont a:hover .icon {
    transform: translateX(10px);
    transition-delay: 0.3s;
  }
}
@media (max-width: 1365px) {
  .insight .inner .content .box {
    padding-bottom: 313px;
  }
  .insight .inner .content .box .data-cont {
    left: 30px;
    bottom: 30px;
  }
  .insight .inner .content .box .data-cont .title {
    font-size: 24px;
  }
}
@media (max-width: 1023px) {
  .insight .inner .content .box .data-cont {
    bottom: 20px;
    left: 20px;
    width: 100%;
  }
  .insight.twoClass .data-cont {
    max-width: 275px;
  }
  .insight .inner .content .box .data-cont a {
    width: 100%;
  }
  .insight .inner .content .box .data-cont a p {
    font-size: 16px;
  }
  .insight .inner .content .box {
    padding-bottom: 260px;
  }
  .insight.twoClass .inner .content .box:nth-child(1) {
    flex: unset;
  }
  .insight.twoClass .inner .content .box {
    width: 100%;
  }
}
@media (max-width: 767px) {
  .insight .inner .content {
    flex-direction: column;
  }
  .insight .inner .content .box {
    width: 100%;
    margin-left: 0px;
    margin-bottom: 30px;
    padding-bottom: 300px;
  }
  .insight .inner .content .box:last-child {
    margin-bottom: 0px;
  }
  .insight .inner .content .box .data-cont {
    width: unset;
    bottom: 30px;
    left: 30px;
  }
  .insight .inner .content .box .data-cont .title {
    font-size: 24px;
  }
  .insight .inner .content .box .data-cont .txt {
    font-size: 16px;
    -webkit-line-clamp: 3;
  }
  .insight .inner .content .box .data-cont .txt * {
    font-size: 16px;
  }
  .insight .inner .top-cont p {
    font-size: 24px;
  }
}
html[lang="ge"] .insight .inner .content .box .data-cont .title {
  text-transform: uppercase;
  -moz-font-feature-settings: "case";
  -webkit-font-feature-settings: "case";
  font-feature-settings: "case" on;
}
</style>
